import { FunctionComponent } from "react";
import { Redirect, Route, Switch } from "react-router";
import { useUser } from "../components/user/user-context";
import { ROUTES } from "../router/router";

export const App: FunctionComponent = () => {
  const { isLoggedIn } = useUser();

  return (
    <Switch>
      <Route path={ROUTES.LOGIN.PATH}>
        <ROUTES.LOGIN.COMPONENT />
      </Route>
      <Route path={ROUTES.PORTAL.PATH}>
        {isLoggedIn() ? <ROUTES.PORTAL.COMPONENT /> : <Redirect to={ROUTES.LOGIN.PATH} />}
      </Route>
      <Redirect to={ROUTES.LOGIN.PATH} />
    </Switch>
  );
};
